import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { rankingItems } from '@/mocks/home';

const trendMap: Record<string, { icon: string; color: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-600', label: '上升' },
  down: { icon: 'ri-arrow-down-line', color: 'text-secondary-600', label: '下降' },
  same: { icon: 'ri-subtract-line', color: 'text-foreground-400', label: '持平' },
};

export default function RankingBoard() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="运营榜单"
          icon="ri-bar-chart-2-line"
          title="本周资源热榜"
          desc="按收藏、下载与讨论热度综合排序，每周一更新，热度散得慢的会一直挂在榜上。"
          action="查看历史榜单"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_300px]">
          <ol className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {rankingItems.map((item, index) => {
              const trend = trendMap[item.trend] || trendMap.same;
              return (
                <Reveal key={item.id} delay={index * 50}>
                  <li className="flex items-center gap-4 border-b border-background-200 px-4 py-4 last:border-b-0 md:px-6">
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                        item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.title}
                      </h3>
                      <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <span className="flex h-3.5 w-3.5 items-center justify-center">
                            <i className="ri-fire-line text-[13px] text-primary-500"></i>
                          </span>
                          热度 {item.score.toLocaleString()}
                        </span>
                        <span className={`flex items-center gap-1 ${trend.color}`}>
                          <span className="flex h-3.5 w-3.5 items-center justify-center">
                            <i className={`${trend.icon} text-[13px]`}></i>
                          </span>
                          {trend.label}
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="shrink-0 cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                    >
                      去看看
                    </button>
                  </li>
                </Reveal>
              );
            })}
          </ol>

          <aside className="flex flex-col gap-4">
            <Reveal>
              <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-calendar-check-line text-base text-accent-700"></i>
                  </span>
                  更新时间
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  每周一上午 10:00 结算上一周期数据，榜单会保留近四周记录。
                </p>
                <div className="mt-4 rounded-md bg-background-50 px-3 py-3">
                  <p className="text-xs text-foreground-500">下一期还剩</p>
                  <p className="mt-1 font-heading text-xl font-bold text-foreground-950">
                    3 天 14 小时
                    <span className="ml-1 text-xs font-normal text-foreground-500">倒计时</span>
                  </p>
                </div>
              </div>
            </Reveal>

            <Reveal delay={100}>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">上榜规则</h3>
                <ul className="mt-3 space-y-2.5 text-sm leading-relaxed text-foreground-600">
                  <li>收藏、下载各占三成热度。</li>
                  <li>讨论量与回帖质量占四成。</li>
                  <li>重复投稿会合并计算，不叠加。</li>
                </ul>
              </div>
            </Reveal>
          </aside>
        </div>
      </div>
    </section>
  );
}